<div *ngIf="this.createCollectionStore.searchProductType$ | async">
  <app-collection-search-filter-bar></app-collection-search-filter-bar>
  <input
    [hidden]="(this.createCollectionStore.searchProductType$ | async) !== 1"
    id="adv"
    type="checkbox"
    (change)="updateAdvancedGarmentSearch($event)"
  />
  <label
    [hidden]="(this.createCollectionStore.searchProductType$ | async) !== 1"
    for="adv"
    >Advanced search</label
  >

  <span
    [hidden]="
      (store.garmentsLoading$ | async) === false ||
      (this.createCollectionStore.searchProductType$ | async) !== 1 ||
      (store.advancedGarmentSearch$ | async) === false
    "
    class="refresh"
    (click)="abort()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 344 480"
    >
      <path
        fill="#000000"
        d="M 171 112 q -53 0 -90.5 37.5 T 43 240 q 0 32 15 60 l -32 31 Q 0 289 0 240 q 0 -71 50 -121 t 121 -50 V 5 l 85 86 l -85 85 v -64 z m 144 37 q 26 42 26 91 q 0 71 -50 121 t -120 50 v 64 l -86 -86 l 86 -85 v 64 q 53 0 90.5 -37.5 T 299 240 q 0 -31 -15 -60 z M 41 45 L 380 428 L 354 452 L 18 63"
      ></path>
    </svg>
  </span>

  <span
    [hidden]="
      (store.garmentsLoading$ | async) === true ||
      (this.createCollectionStore.searchProductType$ | async) !== 1 ||
      (store.advancedGarmentSearch$ | async) === false
    "
    class="refresh"
    (click)="reloadGarments()"
    ><svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 344 480"
    >
      <path
        fill="#000000"
        d="M171 112q-53 0-90.5 37.5T43 240q0 32 15 60l-32 31Q0 289 0 240q0-71 50-121t121-50V5l85 86l-85 85v-64zm144 37q26 42 26 91q0 71-50 121t-120 50v64l-86-86l86-85v64q53 0 90.5-37.5T299 240q0-31-15-60z"
      ></path>
    </svg>
  </span>
  <span *ngIf="store.advancedGarmentSearch$ | async">
    <div
      class="loader"
      [hidden]="
        (store.garmentsLoading$ | async) === false ||
        (this.createCollectionStore.searchProductType$ | async) !== 1
      "
    >
      loading...
      <span *ngIf="totalCount > 0"
        >({{ entryCount }} loaded from {{ totalCount }})</span
      >
    </div>
  </span>
  <div
    *ngIf="
      (store.advancedGarmentSearch$ | async) &&
      (this.createCollectionStore.searchProductType$ | async) === 1
    "
  >
    <hr />
    <div class="advanced-search">
      <div class="selection">
        <input id="hideAdded" type="checkbox" (change)="onHideAdded($event)" />
        <label for="hideAdded">Hide Added</label>
      </div>
      <input
        id="searchText"
        type="text"
        (input)="onSearchText($event)"
        placeholder="Search"
      />
      <span
        >Found {{ (store.allGarments$ | async)?.length ?? 0 }} items.
        <span
          class="refresh"
          (click)="addFilteredGarments()"
          [hidden]="
            (store.garmentsLoading$ | async) === true ||
            (this.createCollectionStore.searchProductType$ | async) !== 1 ||
            (store.advancedGarmentSearch$ | async) === false ||
            (store.allGarments$ | async) === undefined ||
            (store.allGarments$ | async)?.length === 0
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
  <div *ngFor="let r of requestList">
    <app-reference-entry [reference]="r"></app-reference-entry>
  </div>
  <rr-request-list-pagination
    [GotoPageNumber]="true"
  ></rr-request-list-pagination>
</div>
